import React from 'react';
import { Stack, Typography, Button, Select, MenuItem } from '@mui/material';
import StepperDUC from '../duc/StepperDUC';
import { DownloadProcessSteps, stepLabels } from './DataDownloadProcess';
import { colours } from '../../StyleConstants';
import Selector from './components/Selector';

const DownloadDetails = (props: any) => {
   
    const handleClickBack = () => {
        props.setCurStep(DownloadProcessSteps.FileSelection)
    }
    const seletectedFiles = Array.from(props.info.selectedFiles)
    return (
        <Stack gap={3} sx={{ padding: 3 }}>
            <Stack flexDirection="column" gap={4} alignItems="center">
                <Typography
                    variant="h3"
                    fontWeight="600"
                    fontSize="40px"
                    textAlign="center"
                    color={colours.midnightBlue.blue}>
                    New Dataset Download
                </Typography>
                <StepperDUC
                    activeStep={DownloadProcessSteps.DownloadDetails}
                    stepLabels={stepLabels}
                />
            </Stack>

            <Button
                variant="tertiary"
                onClick={() => handleClickBack()}
                sx={{ width: "150px" }}

            >
                Back
            </Button>

            <Stack direction="row" gap={3} sx={{ marginTop: 3 }}>
                <Stack flex={1}>
                    <Typography variant="h6" fontWeight="600" color={colours.orange.orange}>
                        Selected study
                    </Typography>

                    <Selector
                        title = {props.info.study}
                        text = "Information about the Study"/>
                </Stack>

                <Stack flex={1}>
                    <Typography variant="h6" fontWeight="600" color={colours.orange.orange}>
                        Selected release
                    </Typography>

                    <Selector
                        title = {props.info.release}
                        text = "Information about the Study"/>
                </Stack>

                <Stack flex={1}>
                    <Typography variant="h6" fontWeight="600" color={colours.orange.orange}>
                        Selected dataset
                    </Typography>
                    <Selector
                        title = {props.info.dataset}
                        text = "Information about the Study"/>
                </Stack>
            </Stack>

            <Stack>
                <Typography variant="h6" fontWeight="600" color={colours.midnightBlue.blue} sx={{ marginTop: 3 }}>
                    Selected files
                </Typography>


                <Stack gap={2} maxHeight="400px"  sx={{ width: '100%' }} overflow="auto">
                    {seletectedFiles.map((file: any) => (
                        <Selector
                            key={file.title}
                            title={file.title}
                            text={file.size}
                            skinny={true}
                        />
                    ))}
                </Stack>

                <Stack direction="row" justifyContent="center" sx={{ marginTop: 3 }} gap ={4}>
                    <Typography variant="body2" fontWeight="600" color={colours.midnightBlue.blue}>
                        {props.info.selectedFiles.size} files selected
                    </Typography>
                    <Typography variant="body2" fontWeight="600" color={colours.midnightBlue.blue}>
                        20 TB Download size
                    </Typography>
                </Stack>

                <Stack alignItems="center" sx={{ marginTop: 3 }} gap={2}>
                    <Stack direction="row" gap={2} alignItems="center">
                        <Select defaultValue="selected-destination" sx={{ width: '200px' }}>
                            <MenuItem value="selected-destination">Selected destination</MenuItem>
                        </Select>
                        <Button variant="tertiary">
                            New Destination
                        </Button>
                    </Stack>

                    <Button
                        variant="primary"
                        disabled={true}
                    >
                        Download
                    </Button>
                </Stack>
            </Stack>
        </Stack>
    )
}

export default DownloadDetails;
